import { render, staticRenderFns } from "./CustomerHistoryModalComponent.vue?vue&type=template&id=bace0f22&"
import script from "./CustomerHistoryModalComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports